"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 16 16",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "var(--smar--ursa-icons--backgroundColor, transparent)",
  d: "M4 6a3 3 0 0 1 3-3h1a4 4 0 0 1 4 4v3a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M4 7.575c0-.907.005-1.814 0-2.721-.006-1.083.482-1.88 1.387-2.423a3.09 3.09 0 0 1 3.506.25c.669.54 1.02 1.244 1.02 2.117 0 1.655.003 3.31-.001 4.964-.002.696-.273 1.257-.871 1.625-.736.454-1.879.354-2.466-.482-.23-.329-.345-.7-.346-1.1q-.005-2.37-.001-4.739c0-.359.261-.66.596-.699a.685.685 0 0 1 .767.523c.017.07.021.143.022.214q0 2.313.003 4.626a1 1 0 0 0 .06.311.28.28 0 0 0 .231.188 1 1 0 0 0 .298.006c.181-.031.28-.159.311-.338q.017-.095.015-.19c0-1.605-.01-3.211.006-4.817a1.41 1.41 0 0 0-.92-1.361c-.653-.24-1.268-.167-1.802.305a1.24 1.24 0 0 0-.432.967c0 1.811.006 3.622-.002 5.433-.004.773.315 1.368.913 1.823.491.373 1.056.538 1.666.545.653.008 1.255-.164 1.778-.57.454-.35.756-.803.853-1.38q.024-.15.024-.303.002-2.63.001-5.26c0-.356.203-.627.529-.71a.687.687 0 0 1 .85.658c.003 1.809.01 3.618-.002 5.425-.006.837-.323 1.564-.877 2.18-.701.78-1.585 1.21-2.615 1.326-1.2.135-2.284-.169-3.222-.943a3.41 3.41 0 0 1-1.276-2.643Q4 8.978 4.002 7.574z"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=AttachFileIcon16.js.map